import type React from "react";

import { cx, styled } from "simplydo/react/styled";

type IFakeLink = {
  withBorder?: boolean;
  borderColor?: string;
  className?: string;
  style?: object;
  onClick?: () => any;
  children: React.ReactNode;
};

const StyledFakeLink = styled.span`
  cursor: pointer;
  color: ${({ theme }) => theme.primaryColour};
  text-decoration: none;

  &.has-border {
    border-bottom: 1px dotted var(--fake-link-border-color);
  }

  &:hover {
    color: ${({ theme }) => theme.primaryColour};
  }
`;

function FakeLink({
  withBorder,
  borderColor,
  children,
  className,
  style,
  ...rest
}: IFakeLink) {
  return (
    <StyledFakeLink
      className={cx(withBorder && "has-border", className)}
      style={
        withBorder ?
          ({
            ...style,
            "--fake-link-border-color": borderColor,
          } as React.CSSProperties)
        : style
      }
      {...rest}
    >
      {children}
    </StyledFakeLink>
  );
}

export default FakeLink;
